module.exports = __webpack_public_path__ + "static/img/快看快看300x300.6b23b2cf.png";